<template>
    <div>
        <div class="rtitle flex justify-between align-center bg-white rone">
            <div class="colorleft">房租费用</div>
            <div class="colorright"></div>
        </div>
        <div class="cball">
            <div v-if="tabindex == 1" class="bg-white" style="padding: 40px;min-height: 480px;">
                        
                <div class="pointer" v-for="(item,index) in roomlist" :key="index" @click="tonewdetailtwo(item.id)" style="margin-bottom: 20px;">
                    <el-row style="border: 1px solid #eee;padding: 0 10px;border-radius: 8px;">
                        <el-col class="text-left" :span="6">
                            <div class="text-cut newone">
                                房间号: {{item.room_number ? item.room_number : '--'}}
                            </div>
                        </el-col>
                        <el-col class="text-left" :span="6">
                            <div class="text-cut newone">
                                签约时间: {{item.sign_time ? item.sign_time : '--'}}
                            </div>
                        </el-col>
                        <el-col class="text-left" :span="6">
                            <div class="text-cut newone">
                                租赁时长: {{item.lease_time ? item.lease_time : '--'}}
                            </div>
                        </el-col>
                        <el-col class="text-left" :span="6">
                            <div class="text-cut newone">
                                房租到期时间: {{item.expire_time ? item.expire_time : '--'}}
                            </div>
                        </el-col>
                        <el-col class="text-left" :span="6">
                            <div class="text-cut newone">
                                房租价格: {{item.price ? item.price : '--'}}
                            </div>
                        </el-col>
                        <el-col class="text-left" :span="6">
                            <div class="text-cut newone">
                                支付方式: {{item.pay_way ? item.pay_way : '--'}}
                            </div>
                        </el-col>
                        <el-col class="text-left" :span="6">
                            <div class="text-cut newone" v-if="item.remind_time == 1">
                                <span style="color: #ffa200;">1个月内到期，请及时续费</span>
                            </div>
                        </el-col>
                        <el-col class="text-left" :span="6">
                            <div class="text-center flex ">
                                <div style="width: 100px;color: #fff;font-size: 16px;height: 40px;line-height: 40px;border-radius: 6px;background-color: #00c9bd;">查看详情</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="" v-if="!roomlist.length && !load">
                    <el-empty description="暂无数据"></el-empty>
                </div>
                <div class="text-center" style="padding-top: 40px;">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :pager-count="pagerCount"
                        :hide-on-single-page="true"
                        :page-size="pagesizetwo"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :total="totalnum"
                        >
                        </el-pagination>
                </div>
            </div>




            <div v-if="tabindex == 8" class="bg-white" style="padding: 40px;min-height: 480px;position: relative;">
                <div @click="backtwo" class="backbtn">返回</div>
                <div class="flex justify-between flex-wrap" style="padding-top: 20px">
                    <div class="newclass pointer hvr-glow" v-for="(item,index) in newlisttwo" :key="index">
                        <el-row class="rowone">
                            <el-col class="text-right pleft" :span="7">缴费时间</el-col>
                            <el-col class="text-left pright" :span="17">{{item.pay_time}}</el-col>
                        </el-row>
                        <el-row class="rowone">
                            <el-col class="text-right pleft" :span="7">费用到期时间</el-col>
                            <el-col class="text-left pright" :span="17">{{item.expire_time}}</el-col>
                        </el-row>
                        <el-row class="rowone">
                            <el-col class="text-right pleft" :span="7">支付方式</el-col>
                            <el-col class="text-left pright" :span="17">{{item.pay_way}}</el-col>
                        </el-row>
                        <el-row class="rowone">
                            <el-col class="text-right pleft" :span="7">备注</el-col>
                            <el-col class="text-left text-cut pright" :span="17">{{item.remark}}</el-col>
                        </el-row>
                    </div>
                </div>
                <div class="" v-if="!newlisttwo.length && !load">
                     <el-empty description="暂无数据"></el-empty>
                </div>
                <div class="text-center" style="padding-top: 40px;">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :pager-count="pagerCount"
                        :hide-on-single-page="true"
                        
                        :page-size="newpagestwo"
                        @size-change="schangetwo"
                        @current-change="curchangetwo"
                        :current-page="currentstwo"
                        :total="totalstwo"
                        >
                        </el-pagination>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
export default ({
    data() {
        return{
            config: '',
            roomlist: [],
            pagerCount: 7,
            pagesizetwo: 5,
            totalnum: 0,
            currentPage: 1,
            load: true,
            userinfo: '',
            tabindex: 1,

            currentstwo: 1,
            newpagestwo: 5,
            newlisttwo: [],
            totalstwo: 0,
            id: 0
        }
    },
    methods:{
        backtwo(){
            this.roomlist = [];
            this.currentPage = 1;
            this.totalnum = 0;
            this.load = true;
            this.getmyroom();
            this.tabindex = 1;
        },
        curchangetwo(currentPage){
            this.currentstwo = currentPage;
            this.tonewdetailtwo();
        },
         schangetwo(){

        },
        tonewdetailtwo(id){
            this.id = id;
            var data = {
                id: this.id,
                start: this.currentstwo,
                page_size: this.newpagestwo,
                type: 2
            }
            this.tabindex = 8;
            this.$api.index.my_record(data).then(res=>{
                console.log(res)
                this.newlisttwo = res.data;
                this.totalstwo = res.count;
                this.load = false;
            }).catch(res=>{
                // console.log(res,1111111111)
                this.load = false;
            })
        },
        getconfig(){
            this.$api.index.config().then(res=>{
                this.config = res.data;
            })
        },
        handleSizeChange(){

        },
        handleCurrentChange(currentPage){
            this.currentPage = currentPage;
            this.getmyroom();
        },
        getmyroom(){
            var data = {
                shop_id: this.userinfo.shop.id,
                start: this.currentPage,
                page_size: this.pagesizetwo
            }
            this.$api.index.my_room(data).then(res=>{
                console.log(res)
                this.roomlist = res.data;
                this.totalnum = res.count;
                this.load = false;
            }).catch(res=>{
                // console.log(res,1111111111)
                this.load = false;
            })
        },
    },
    created(){
        this.userinfo = JSON.parse(localStorage.getItem('userinfo'));
        this.getconfig();
        this.getmyroom();
    }
})
</script>

<style scoped>
    .rtitle{
        padding: 20px;
        font-size: 16px;
        color: #7d7d7d;
        border-bottom: 8px solid #f4f4f4;
    }
    .rone{
        border-radius: 12px 12px 0 0;
    }
    .colorleft{
        color: #191919;font-size: 20px;
    }
    .colorright{
        color: #7e7e7e;font-size: 18px;
    }

    .newone{
        width: 90%;height: 50px;line-height: 50px;
    }

    .backbtn{
        width: 82px;
        height: 35px;
        line-height: 35px;
        background-color: #00c9bd;
        border-radius: 6px;
        color: #fff;font-size: 16px;
        position: absolute;
        top: 13px;left: 10px;
        text-align: center;
        cursor: pointer;z-index: 9999;
    }
    .rowone{
        height: 60px;line-height: 60px;
    }
    .pleft{
        color: #a0a0a0;font-size: 18px;
    }
    .pright{
        padding-left: 45px;
        color: #151515;font-size: 18px;
    }
    .newclass{
        width: 48%;border: 1px solid #eee;border-radius: 10px;
        
        /* box-shadow: 6px 6px 8px rgba(26, 26, 26, 0.2) */
    }
</style>


// WEBPACK FOOTER //
// room_price.vue?68b5b3d3